import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractType, contractTypeT } from '../../../common/enums';
import { selectToken } from '../../../features/auth/ducks';
import { apiCallIds } from '../api';
import { getFileUrl } from '../../../common/utils/helpers';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { translate } from 'react-i18next';
import SignBlock from '../../../features/dashboard/components/registration-action-alert/SignBlock';
import Button from 'antd/lib/button';
import { signLoanActions } from '../ducks';


const mapStateToProps = state => ({
  token: selectToken(state),
  isLoading: selectIsInProgress(state, apiCallIds.SIGN_LOAN)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signLoanContract: signLoanActions.request,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class SignLoanContractBlock extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        actions: PropTypes.object.isRequired,
        loan: PropTypes.object,
        token: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    };

    state = {
        checked: false
    }
    
    handleSubmit = () => {
        const { actions, loan } = this.props;
        actions.signLoanContract({ loanId: loan.id });
    };

    onChecked = (val) => {
        this.setState({ checked: val });
    }
    
    render() {
        const { isLoading, token, loan, t } = this.props;
    
        if (!loan) {
            return null;
        }
        const contract = loan.contracts.find(c => c.type === contractType.MANDATE);
    
        let fileLocation = null;
        if (contract) {
            fileLocation = getFileUrl(contract.fileId, token)
        }
    
        if (!contract) {
            return null;
        }

        let modalText = t(
            'Dlžník sa oboznámil so znením Záväznej žiadosti o pôžičku (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Záväznú žiadosť o pôžičku” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.'
        )

        let checkBoxText = t('Súhlasím so Záväznou žiadosťou o pôžičku')
        let buttonText = t('Potvrdiť Záväznú žiadosť o pôžičku')
        
        return (
            <div>
                <SignBlock
                    isLoading={isLoading}
                    fileLocation={fileLocation}
                    onChecked={(val) => this.onChecked(val)}
                    title={contractTypeT.MANDATE_DEBTOR}
                    text={modalText}
                    checkboxText={checkBoxText}
                    fileLinktext={t('Prečítať Záväznú žiadosť o pôžičku')}
                    buttonText={buttonText}
                    isChecked={this.state.checked}
                />
                <div className='ant-modal-footer'>
                    <Button
                        size="small"
                        type="primary"
                        loading={isLoading}
                        onClick={this.handleSubmit}
                        disabled={!this.state.checked}
                    >
                    { t('Potvrdiť Záväznú žiadosť o pôžičku') }
                    </Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/SignLoanContractBlock.js